import { createLazyComponent, registerLazyOrchestrator, LazyImport, LazyAction, type LazyComponent, } from "owa-bundling";
import { resetSearchStore } from "owa-search-actions/lib/actions/resetSearchStore";
import { startSearchSession } from "owa-search-actions/lib/actions/startSearchSession";
import { startSearch } from "owa-search-actions/lib/actions/startSearch";
import { invoke3sSearchForTab } from "./actions/invoke3sSearchForTab";
import { lazyModule } from "./lazyFunctions";
import type { setLoadingState, resetTabbedSearchResults, setActiveSearchTab, getActiveScopeTabIndex, getSearchItemsByTab, } from "./lazyIndex";
import type { TabbedSearchPaneProps } from "./components/TabbedSearchPane";
import type { TabbedScopedSuggestionsProps } from "./components/TabbedScopedSuggestions";

// Export interfaces and enums
export { TabbedSearchLoadingState } from "./store/TabbedSearchStore";
export type { default as TabbedSearchStore } from "./store/TabbedSearchStore";

// Export lazy selectors
export const lazyGetActiveScopeTabIndex: LazyImport<typeof getActiveScopeTabIndex, typeof lazyModule> = new LazyImport(lazyModule, m => m.getActiveScopeTabIndex);
export const lazyGetSearchItemsByTab: LazyImport<typeof getSearchItemsByTab, typeof lazyModule> = new LazyImport(lazyModule, m => m.getSearchItemsByTab);

// Export lazy actions
export const lazySetLoadingState: LazyAction<typeof setLoadingState, typeof lazyModule> = new LazyAction(lazyModule, m => m.setLoadingState);
export const lazyResetTabbedSearchResults: LazyAction<typeof resetTabbedSearchResults, typeof lazyModule> = new LazyAction(lazyModule, m => m.resetTabbedSearchResults);
export const lazySetActiveSearchTab: LazyAction<typeof setActiveSearchTab, typeof lazyModule> = new LazyAction(lazyModule, m => m.setActiveSearchTab);
export const lazyInvoke3sSearchForTab: LazyAction<typeof invoke3sSearchForTab, typeof lazyModule> = new LazyAction(lazyModule, m => m.invoke3sSearchForTab);

export { lazySetShouldSuppressTabs } from "./lazyFunctions";

// Export lazy components
export const TabbedSearchPivot: LazyComponent<{}, unknown, void> = createLazyComponent(lazyModule, m => m.TabbedSearchPivot);
export const TabbedScopedSuggestions: LazyComponent<TabbedScopedSuggestionsProps, unknown, void> = createLazyComponent(lazyModule, m => m.TabbedScopedSuggestions);
export const TabbedSearchPane: LazyComponent<TabbedSearchPaneProps, unknown, void> = createLazyComponent(lazyModule, m => m.TabbedSearchPane);

// Register lazy orchestrator
registerLazyOrchestrator(resetSearchStore, lazyModule, m => m.resetSearchStoreOrchestrator);
registerLazyOrchestrator(invoke3sSearchForTab, lazyModule, m => m.invoke3sSearchForTabOrchestrator);
registerLazyOrchestrator(startSearchSession, lazyModule, m => m.searchSessionStartedOrchestrator);
registerLazyOrchestrator(startSearch, lazyModule, m => m.startSearchOrchestrator);

// Export utils
export { default as isTabbedSearchEnabled } from "./utils/isTabbedSearchEnabled";
export { default as getIsNonMailEntitySearchTab } from "./selectors/getIsNonMailEntitySearchTab";
export { default as getActiveSearchTab } from "./selectors/getActiveSearchTab";
export { default as getActiveScopeTab } from "./selectors/getActiveScopeTab";
export { default as getActiveScopeTabForScenario } from "./selectors/getActiveScopeTabForScenario";
